import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import { usePlayerMenuStore } from "@/domains/playerMenu/store";
import { subHeaderIcon } from "@/domains/playerMenu/helpers/subHeaderIcons";
import PlayerMenuSubHeaderTab from "@/domains/playerMenu/components/subHeader/PlayerMenuSubHeaderTab";

export default function PlayerMenuSubHeaderContainer() {
  const { play } = useInterfaceSoundCore(Soundtrack.DefaultClick);
  const { t } = useTranslation("playerMenu");
  const { currSubHeaderTab, subHeaderTabs, currHeaderTab, changeSubHeaderTab } =
    usePlayerMenuStore();

  const tabs = useMemo(
    () => (currHeaderTab ? subHeaderTabs[currHeaderTab] : []),
    [currHeaderTab, subHeaderTabs],
  );

  useEffect(() => {
    changeSubHeaderTab(tabs[0]);
  }, [tabs, changeSubHeaderTab]);

  return (
    <div className="w-[15rem] px-10 py-7.5 flex flex-col gap-2.5">
      {tabs.map((item) => (
        <PlayerMenuSubHeaderTab
          key={item}
          isActive={item === currSubHeaderTab}
          onClick={() => {
            play();
            changeSubHeaderTab(item);
          }}
          icon={subHeaderIcon[item]({ size: 16, className: "z-1" })}
          label={t(`playerMenu.subHeaderTab.${item}`)}
        />
      ))}
    </div>
  );
}
